import { styled } from '@mui/material/styles';
import { getIdvThemeTokens } from '../themeTokens';

export const LoadingRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '48px 16px',
  color: getIdvThemeTokens(theme).textMuted,
}));

export const LoadingLabel = styled('p')({
  margin: 0,
  fontSize: 13,
});
